import React, { Fragment } from 'react';
import styled from 'styled-components';
import {
  Table,
  Tr,
  TrHead,
  Th,
  TBody,
  Td,
  LoadingBlueLarge,
} from 'merchant-portal-components';
import { TooltipIcon } from '../../../../../components/Icon';
import { Tooltip, Switch, Box } from '@material-ui/core';
import NoDataMessage from '../../../../../components/NoDataMessage/NoDataMessage';

const TableWrapper = styled.div`
  overflow-x: auto;
  border-radius: 12px;
`;
const renderList = (
  allVariants,
  toggleIsActive,
  variantIsSaving,
  setEditVariant,
  requestParams,
  searchString,
  isGetVariantRequest,
  isSearching,
  selectedFilter
) => {
  return (
    <TableWrapper>
      {isGetVariantRequest || isSearching ? (
        <Box sx={{ borderTop: '1px solid lightgray' }}>
          <LoadingBlueLarge />
        </Box>
      ) : allVariants.length > 0 ? (
        requestParams && (
          <Table style={{ border: 'none' }}>
            {renderTableHeader(requestParams)}
            <TBody>
              {renderTableRows(
                allVariants,
                toggleIsActive,
                variantIsSaving,
                setEditVariant,
                requestParams,
                searchString
              )}
            </TBody>
          </Table>
        )
      ) : (
        <Box sx={{ borderTop: '1px solid lightgray' }}>
          <NoDataMessage
            selectedFilter={selectedFilter}
            searchString={searchString}
            type='Variants'
          />
        </Box>
      )}
    </TableWrapper>
  );
};

const renderTableHeader = (requestParams) => {
  return (
    <TrHead>
      <Th
        align='left'
        value='name'
        sortingOption={requestParams.sorting_option}
        style={{ paddingLeft: '37px' }}
      >
        Name
      </Th>
      <Th align='left'>
        Label
        <Tooltip
          style={{ marginRight: 'auto' }}
          title='This is an internal label to help you identify the type of variant.This will not appear to your customers'
        >
          <span>
            <TooltipIcon marginLeft />
          </span>
        </Tooltip>
      </Th>
      <Th
        align='right'
        value='is_active'
        sortingOption={requestParams.sorting_option}
        style={{ paddingRight: '45px' }}
      >
        Active
      </Th>
    </TrHead>
  );
};
const renderTableRows = (
  allVariants,
  toggleIsActive,
  variantIsSaving,
  setEditVariant
) => {
  return allVariants.map((variant, index) => (
    <Tr
      key={index}
      style={{ height: '78px', color: '#191818', cursor: 'pointer' }}
      onClick={() => !variantIsSaving && setEditVariant(variant)}
    >
      <Td padding={'0px 0px 0px 37px'}>{variant.name}</Td>
      <Td>{variant.label}</Td>
      <Td padding={'0px 37px 0px 0px'} style={{ textAlign: 'right' }}>
        <Switch
          checked={variant.is_active}
          onClick={(e) => e.stopPropagation()}
          onChange={() => toggleIsActive(variant)}
          disabled={variantIsSaving}
          value='checkedB'
          color='primary'
          inputProps={{ 'aria-label': 'primary checkbox' }}
        />
      </Td>
    </Tr>
  ));
};

const VariantList = ({
  allVariants,
  requestParams,
  isGetVariantRequest,
  toggleIsActive,
  setEditVariant,
  variantIsSaving,
  searchString,
  isSearching,
  selectedFilter,
}) => {
  return (
    <Fragment>
      {renderList(
        allVariants,
        toggleIsActive,
        variantIsSaving,
        setEditVariant,
        requestParams,
        searchString,
        isGetVariantRequest,
        isSearching,
        selectedFilter
      )}
    </Fragment>
  );
};

export default VariantList;
